<template>
    <div class="zl-page  flex_default_center">
        <div class="zl-content flex">
            <div @click="toPage(0)" class="zl-box flex_column_align_center">
            
                <div class="zl-icon flex_default_center">
                    <img src="../../assets/img/zl.png" alt="">
                </div>
                <p>{{$t('zlfk.zc')}}</p>
                <span>Vehicle quality feedback</span>
            </div>
            <div @click="toPage(1)" class="zl-box flex_column_align_center">

                <div class="zl-icon flex_default_center">
                    <img src="../../assets/img/kd.png" alt="">
                </div>
                <p>{{$t('zlfk.kd')}}</p>
                <span>KD quality feedback</span>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    methods:{
        toPage(type){
            if(type==0){
                this.$router.push('/quality/allcar')
            }else{
                //   this.$router.push('/quality/kd')
                this.$message({
                    type:'warning',
                    message:'玩命开发中...'
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.zl-page{
    padding-top: 100px;
    .zl-content{
        width: 90%;
    }
    .zl-icon{
        background: #fff;
        box-sizing: border-box;
        width: 200px;
        height: 200px;
        border: 6px solid #000;
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 6px 0px;
        img{
            width: 100px;

        }
    }
    .zl-box{
        width: 50%;
        text-align: center;
        color: #000;
        cursor: pointer;
        p{
            font-size: 20px;
            font-weight: bold;
            line-height: 60px;
        }
        span{
            font-size: 18px;
        }
    }
}
</style>